import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BatchSubmissionService {

  constructor(private http: HttpClient) { }

  submitBatch(efileBaseUrl: string, subIds: string, env: string): Observable<any> {
    const url = `${efileBaseUrl}/submitBatch?subIds=${encodeURIComponent(subIds)}&env=${encodeURIComponent(env)}`;
    return this.http.get<any>(url, { withCredentials: true });
  }
}
